import React, { useState, useEffect } from "react";
import axios from "axios";
import { IoInformationCircleOutline } from "react-icons/io5";
import toast, { Toaster } from "react-hot-toast";
import { MdOutlineCancel } from "react-icons/md";
import { DiscardModal } from "./DiscardModal";
import Swal from "sweetalert2";
import "react-tooltip/dist/react-tooltip.css";
import moment from "moment/moment";
import { FaMinus, FaPlus } from "react-icons/fa";
import { useSelector } from "react-redux";
import api from "../../../utils/api";
import { Alert, OverlayTrigger, Tooltip } from "react-bootstrap";
import { formatRupees } from "../../../utils/inputsValidation";
import NomineeDetailsDraft from "./modals/NomineeDetailsDraft";

const DraftGoalTable = ({
  roomId,
  setWarmingNewInvestment,
  setIsFolios,
  isSIPSuccess,
  setSIPSuccess,
  isRedeemSuccess,
  setRedeemSuccess,
  initiatedFolios,
  setInitiatedFolios,
  loading,
  setLoading,
  getDraftGoalData,
  setStopSIP,
  isStopSIP,
}) => {
  // console.log('isSIPSuccess',isSIPSuccess);
  const [goalData, setGoalData] = useState({});
  const [activeFolio, setActiveFolio] = useState(null);
  const {
    clientData,
    loading: clientLoading,
    error: clientError,
  } = useSelector((state) => state.client);

  const [showDiscardModal, setShowDiscardModal] = useState(false);
  const [isDiscardRemark, setIsDiscardRemark] = useState("");


  const [nomineeModalData, setNomineeModalData] = useState(null);
  const [showNomineeModal, setShowNomineeModal] = useState(false);

  // 🔹 For nominee queue & index
  const [uccQueue, setUccQueue] = useState([]);
  const [currentUccIndex, setCurrentUccIndex] = useState(0);




  const [isEventTitle, setIsEventTitle] = useState("");
  const [isSend, setIsSend] = useState(true);
  const [isEdit, setIsEdit] = useState(true);
  const [isDiscard, setIsDiscard] = useState(true);
  const [alertMessage, setAlertMessage] = useState({
    visible: false,
    message: "",
    variant: "",
  });
  const [showNomineeAuthenticationModal, setShowNomineeAuthenticationModal] =
    useState(false);
  const [nomineeAuthenticationModalData, setNomineeAuthenticationModalData] =
    useState({ allucccount: "" });

  console.log("isSend", isSend);
  const [openGoals, setOpenGoals] = useState({});
  // Totals for various transactions
  const [totals, setTotals] = useState({
    sipStartTotal: 0,
    lumpsumAmountTotal: 0,
    stpAmountTotal: 0,
    sipStopTotal: 0,
    redeemAmountTotal: 0,
  });


                  console.log('tarj',initiatedFolios[0]?.acceptedOnce ||(
                  initiatedFolios[0]?.eventStatus !== "Draft" && initiatedFolios[0]?.eventStatus !== "Editing" ),
                initiatedFolios[0]?.acceptedOnce ,(
                  initiatedFolios[0]?.eventStatus !== "Draft" && initiatedFolios[0]?.eventStatus !== "Editing" ),"draft",initiatedFolios[0]?.eventStatus !== "Draft" ,
                  'editing',initiatedFolios[0]?.eventStatus !== "Editing"
                
                
                );
  const handleRemoveGoal = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This transaction will be removed!",
      icon: false,
      html: `
        <input type="text" id="remark-input" class="swal2-input w-75" placeholder="Enter your remark" />
      `,
      showCancelButton: true,
      confirmButtonColor: "green",
      cancelButtonColor: "grey",
      confirmButtonText: "Yes",
      preConfirm: () => {
        const remark = Swal.getPopup().querySelector("#remark-input").value;
        if (!remark) {
          Swal.showValidationMessage("Remark is required");
        }
        return remark;
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const remark = result.value;
          const response = await api.post(`advisor/cancel_folios`, {
            id: id,
            // client_id: roomId,
            remarks: remark,
          });
          getDraftGoalData();
          console.log(response.data);
          setIsDiscard(false);

          Swal.fire({
            title: "Success",
            text: "Transaction removed successfully!",
            icon: "success",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "swal-confirm-btn",
            },
          });
        } catch (error) {
          console.error("Error discarding event:", error);
          if (error.response) {
            toast.error(
              `Error: ${error.response.data.message || "An error occurred"}`
            );
          } else {
            toast.error("An unexpected error occurred.");
          }
        }
      }
    });
  };

  useEffect(() => {
    if (!isEdit) {
      console.log("isEdit", isEdit);
      setWarmingNewInvestment(true);
    }

    setWarmingNewInvestment(false);
  }, [isEdit, isSend, roomId]);

  useEffect(() => {
    if (roomId) {
      getDraftGoalData();

      // isEdit===true&&getEventTitle('Goal Event')
      // isSend===true&&getEventTitle('Draft Goal Event')

      // setIsSend(true);
      // setIsEdit(true);
      setIsDiscard(true);
    }
  }, [roomId, isDiscard, isSIPSuccess, isRedeemSuccess, isStopSIP]);

  useEffect(() => {
    const goalMap = {};
    initiatedFolios?.forEach((folio) => {
      if (!goalMap[folio.goal_name]) {
        goalMap[folio.goal_name] = [];
      }
      goalMap[folio.goal_name].push(folio);
    });
    setGoalData(goalMap);
  }, [initiatedFolios]);

  const toggleGoal = (goalName) => {
    setOpenGoals((prev) => ({ ...prev, [goalName]: !prev[goalName] }));
  };

  console.log('initiatedFolios',initiatedFolios);
  

  const getEventTitle = () => {
    const status = initiatedFolios[0]?.eventStatus;
    const eventTypes = [
      "Processed",
      "Failed",
      "Rejected",
      "Resent",
      "Awaiting Authentication",
      "Sent",
    ];
    setIsEventTitle(
      eventTypes.includes(status) ? "Goal Event" : "Draft Goal Event"
    );
    // console.log("status",eventTypes.includes(status) ? "Goal Event" : "");
    // return eventTypes.includes(status) ? 'Goal Event' : 'Draft Goal Event';
  };
  useEffect(() => {
    getEventTitle();
    const calculateTotals = () => {
      const totals = {
        sipStartTotal: 0,
        lumpsumAmountTotal: 0,
        stpAmountTotal: 0,
        sipStopTotal: 0,
        redeemAmountTotal: 0,
      };

      const goalMap = {};

      initiatedFolios?.forEach((folio) => {
        if (!goalMap[folio.goal_name]) {
          goalMap[folio.goal_name] = {
            sipStart: 0,
            lumpsumAmount: 0,
            stpAmount: 0,
            sipStop: 0,
            redeemAmount: 0,
            transactions: [],
          };
        }

        const currentGoal = goalMap[folio.goal_name];

        switch (folio.tran_financial_document_type) {
          case "SIP":
            currentGoal.sipStart += parseInt(folio.tran_no_of_unites) || 0;
            totals.sipStartTotal += parseInt(folio.tran_no_of_unites) || 0;
            break;
          case "ReInvest":
            currentGoal.lumpsumAmount += parseInt(folio.tran_no_of_unites) || 0;
            totals.lumpsumAmountTotal += parseInt(folio.tran_no_of_unites) || 0;
            break;
          case "SIP_Stop":
            currentGoal.sipStop += parseInt(folio.tran_no_of_unites) || 0;
            totals.sipStopTotal += parseInt(folio.tran_no_of_unites) || 0;
            break;
          case "STP Start":
            currentGoal.stpAmount += parseInt(folio.tran_caluclate_amount) || 0;
            totals.stpAmountTotal += parseInt(folio.tran_caluclate_amount) || 0;
            break;
          case "Redemption":
            currentGoal.redeemAmount += parseInt(folio.tran_no_of_unites) || 0;
            totals.redeemAmountTotal += parseInt(folio.tran_no_of_unites) || 0;
            break;
          default:
            break;
        }
        currentGoal.transactions.push(folio);
      });

      setGoalData(goalMap);
      // console.log("totals", totals);

      setTotals(totals);
    };

    if (initiatedFolios?.length > 0) calculateTotals();
  }, [initiatedFolios]);

  if (loading) return <div>{/* Loading... */}</div>;
  if (!initiatedFolios?.length) return <div>{/* No Open Transactions */}</div>;

//   const proceedGoalEvent = async () => {
//     try {
//       const response = await api.get(`advisor/send_goal_event/${roomId}`);
//       console.log("Response received:", response.data);

//       setIsSend(false);
//       setIsEdit(true);
//       setIsDiscard(false);
//       getDraftGoalData();
//       Swal.fire({
//         title: "Goal Event has been initiated",
//         icon: null, // Hides the icon
//         confirmButtonText: "OK",
//         customClass: {
//           confirmButton: "swal-confirm-btn  ",
//         },
//       });
//     } catch (error) {
//       console.error("Error sending goal event:", error);

//       // Provide detailed error messages if available
//       const errorMessage =
//         error.response?.data?.message ||
//         "An error occurred while sending the event.";

//       // Show error toast
//       toast.error(errorMessage, {
//         style: {
//           border: "1px solid #f44336",
//           padding: "16px",
//           color: "#f44336",
//         },
//         iconTheme: {
//           primary: "#f44336",
//           secondary: "#ffffff",
//         },
//       });
//     }
//   };


//     const checkNominationNew = async()=>{

//       try {
//         const response = await api.post(`advisor/fetch_all_nominees`, {   
//         client_id: roomId,
//       });
//         console.log("Response received:", response.data);
       
//       } catch (error) {
//         console.error("Error sending goal event:", error);
  
//         // Provide detailed error messages if available
//         const errorMessage =
//           error.response?.data?.message ||
//           "An error occurred while sending the event.";
  
//         // Show error toast
//         toast.error(errorMessage, {
//           style: {
//             border: "1px solid #f44336",
//             padding: "16px",
//             color: "#f44336",
//           },
//           iconTheme: {
//             primary: "#f44336",
//             secondary: "#ffffff",
//           },
//         });
//       }
      
//     }
   
//   const sendEvent = async () => {
    
   
//     try {
//       const { data, status }  = await checkNominationNew(clientData);

//       console.log("Nominees API:", { httpStatus: status, data });

//       const appOk =
//         (typeof data?.status === "string" && data.status.toLowerCase() === "success") ||
//         data?.success === true ||
//         status === 200;

//       const nominees = Array.isArray(data?.data)
//         ? data.data
//         : Array.isArray(data)
//         ? data
//         : [];

//       const hasNominees = nominees.length > 0;
//       // console.log('hasNominees',hasNominees,nominees);

//       if (!appOk && !hasNominees) {
//         setShowNomineeAuthenticationModal(true);
//         setAlertMessage?.({ visible: false });
//       } else {
//         proceedGoalEvent();
//       }
//     } catch (err) {
//       console.error("fetch_all_nominees error:", err);
//       const msg =
//         err?.response?.data?.message ||
//         err?.message ||
//         "Failed to fetch nominees. Please try again.";
//       toast?.error(msg);
//       setAlertMessage?.({ visible: true, variant: "danger", text: msg });
//       // Optional: decide whether to proceed or block on error
//       // proceedGoalEvent();
//     } finally {
//     }
//   };

//   // Utility function to check if nominee update is required
// function needsNomineeUpdate(nominee) {
//   if (!nominee) return false;

//   // Agar tax_status '02' ya 'HUF' hai to nominee update ki zarurat nahi
//   if (nominee.tax_status === "02" || nominee.tax_status === "HUF") {
//     return false;
//   }

//   // Required fields check
//   const missingFields =
//     !nominee.NOM1_IDNO ||
//     !nominee.NOM1_ID_TYP ||
//     !nominee.NOM1_EMAIL ||
//     !nominee.NOM1_ADD1;

//   return missingFields;
// }



// Utility function
function needsNomineeUpdate(nominee) {

  if (!nominee) return false;

  
  if (nominee.tax_status === "02" || nominee.tax_status === "HUF") {
    return false;
  }
  console.log('nominee',nominee,!nominee.NOM1_IDNO ||
    !nominee.NOM1_ID_TYP ||
    !nominee.NOM1_EMAIL ||
    !nominee.NOM1_ADD1);

  return (
    !nominee.NOM1_IDNO ||
    !nominee.NOM1_ID_TYP ||
    !nominee.NOM1_EMAIL ||
    !nominee.NOM1_ADD1
  );
}

// API: fetch nominees
const checkNominationNew = async (clientId) => {
  try {
    const response = await api.post(`advisor/fetch_all_nominees`, {
      client_id: clientId,
    });
    return response;
  } catch (error) {
    console.error("Error fetching nominees:", error);
    throw error;
  }
};

// Goal Event API
const proceedGoalEvent = async () => {
  try {
    const response = await api.get(`advisor/send_goal_event/${roomId}`);
    console.log("Response received:", response.data);

    setIsSend(false);
    setIsEdit(true);
    setIsDiscard(false);
    getDraftGoalData();

    Swal.fire({
      title: "Goal Event has been initiated",
      icon: null,
      confirmButtonText: "OK",
      customClass: {
        confirmButton: "swal-confirm-btn",
      },
    });
  } catch (error) {
    console.error("Error sending goal event:", error);

    const errorMessage =
      error.response?.data?.message ||
      "An error occurred while sending the event.";

    toast.error(errorMessage, {
      style: {
        border: "1px solid #f44336",
        padding: "16px",
        color: "#f44336",
      },
      iconTheme: { primary: "#f44336", secondary: "#fff" },
    });
  }
};

// Nominee Modal Flow
const showNextNomineeModal = (uccQueue, currentUccIndex, setCurrentIndex) => {



if (currentUccIndex >= uccQueue.length) {
  proceedGoalEvent();
  return;
}
console.log('uccQueue',uccQueue, currentUccIndex);

  const nominee = uccQueue[currentUccIndex];
  const needsUpdate = needsNomineeUpdate(nominee);

  console.log('needsUpdate',needsUpdate);
  

  if (!needsUpdate) {
    setCurrentIndex((prev) => prev + 1);
    showNextNomineeModal(uccQueue, currentUccIndex + 1, setCurrentIndex);
    return;
  }

  //  modal open
  setShowNomineeAuthenticationModal(true);
  setAlertMessage?.({ visible: false });
  setNomineeAuthenticationModalData({
    clientCode: nominee.client_code,
    name: nominee.nominee_1_name,
    relationship: nominee.nominee_1_relationship,
    applicable: nominee.nominee_1_applicable_,
    mobile: nominee.NOM1_MOB,
    email: nominee.NOM1_EMAIL,
    address: nominee.NOM1_ADD1,
    city: nominee.NOM1_CITY,
    pincode: nominee.NOM1_PIN,
    idType: nominee.NOM1_ID_TYP,
    idNo: nominee.NOM1_IDNO,
  })
 };

 const handleSkipNominee = () => {
  // hide current modal
  setShowNomineeAuthenticationModal(false);

  // optional: stop nominee loop completely
  setUccQueue([]);
  setCurrentUccIndex(0);

  // directly proceed
  proceedGoalEvent();
};


// sendEvent main function
const sendEvent = async () => {
  try {
    const response = await checkNominationNew(roomId);
    const res = response?.data
    // console.log("Nominees API:",res);

    const appOk =(typeof res?.status === "string" && res.status.toLowerCase() === "success") 
                  ||res?.success === true ||res?.status === 200;
     


    const nominees = Array.isArray(res?.data)? res.data: Array.isArray(res?.data)? res?.data: [];
      // console.log("Nominees API:",res,appOk,nominees);

    if (appOk && nominees.length > 0) {
      console.log("Nominees API:",res,appOk,nominees);

      setUccQueue(nominees);
      setCurrentUccIndex(0);
      showNextNomineeModal(nominees, 0, setCurrentUccIndex);

    } else {
      // Swal.fire("Info", "No nominee data found.", "info");
      proceedGoalEvent();
    }
  } catch (err) {
    console.error("fetch_all_nominees error:", err);
    const msg =
      err?.response?.data?.message ||
      err?.message ||
      "Failed to fetch nominees. Please try again.";

    toast.error(msg);
  }
};


  const editEvent = async (id) => {
    // setIsEventTitle("Draft Goal Event");
    try {
      const response = await api.get(`advisor/edit_goal_event/${id}`);
      console.log("lll", response.data);
      setIsSend(true);
      setIsEdit(false);
      setIsDiscard(false);
      getDraftGoalData();
      // Swal.fire({
      //   title: response.data,
      //   confirmButtonText: "OK",
      //   customClass: {
      //     confirmButton: "swal-confirm-btn  ",
      //   },
      //   icon: null,
      // });
    } catch (error) {
      console.error("Error fetching  data:", error);
      toast.error("An error occurred while fetching data.");
    }
  };

  const discardEvent = async () => {
    setShowDiscardModal(true);
  };

  const validStatuses = [
    // "Processed",
    "Sent",
    // "Failed",   //COMMENTED AFTER DISCUSS
    "Rejected",
    "Resent",
    "Awaiting Authentication",
  ];
// console.log('tarj1',initiatedFolios)

  const nomineeDetailsModalHide = () => {
    setShowNomineeAuthenticationModal(false);
    setAlertMessage({ visible: false });
  };

  const getGoalMessage = (folios, goalName, goalYear) => {
    // const selectedFolios = folios.filter((folio) => folio.isChecked);
    // here not need checkbox
    // console.log('hi1',folios);
    // --- Total Amount Calculation (same as PHP) ---
    const totalAmount = folios.reduce((sum, f) => {
      
      const d = Number(f.goal_folio_trans?.sipDeficit) || 0;
      const minus =
      (f.tran_form_type === "Redeem" || f.tran_form_type === "Stop_sip") &&
      f.trans_status !== "Discarded";
     
      console.log("dsd",d);
      
      return sum + (minus ? -d : d);
    }, 0);
    
    
    // Format INR and ensure absolute value for negative case
    const formattedAmount = formatRupees(totalAmount);
    console.log("totalAmount",folios, totalAmount,formattedAmount,goalName);
    
    // Check if it’s a "common goal" (for text “your” or not)
    const isCommonGoal =
    goalName.includes("Marriage") ||
    goalName.includes("Graduation") ||
    goalName.includes("Post Graduation");
    const yours =
    isCommonGoal || goalName.trim().split(" ").length <= 1 ? "" : " your";
    
    // --- Unmapped Goals ---
    if (goalName === "Unmapped Folio" || goalName === "Unmapped Folios") {
      return (
        <div className="alert alert-warning">
        <strong>Note:</strong> This folio is not mapped to any goal.
        </div>
      );
    }
    
    // --- Current Year Goals ---
    if (goalYear === new Date().getFullYear().toString()) {
      return (
        <div className="row bg-light">
        <div className="col-md-2">
        <img
        src="/assets/images/Goal-Event.svg"
        alt="Success"
        style={{ width: "6.2vw" }}
        />
        </div>
        <div className="col-md-10 pt-3">
        <p className="fs-14 fw-normal text-left w-100 mx-auto">
        <b>Congratulations,</b> you have successfully achieved{yours}{" "}
        <span className="fs-14 fw-semibold clrgreen">{goalName}</span> goal.
        </p>
        </div>
        </div>
      );
    }
    
    // --- Positive Impact (add) ---
    if (totalAmount > 0) {
      return (
        <div className="row">
        <div className="col-md-2">
        <img
        src="/assets/images/Goal-Event.svg"
        alt="Success"
        style={{ width: "6.2vw" }}
        />
        </div>
        <div className="col-md-10 pt-3">
        <p className="fs-14 fw-normal text-left w-100 mx-auto">
        This Goal Event will add a total of{" "}
        <span className="fs-14 fw-semibold clrgreen">
        {formattedAmount}
        </span>{" "}
        to{yours}{" "}
        <span className="fs-14 fw-semibold clrgreen">{goalName}</span> goal
        by the year{" "}
        <span className="fs-14 fw-semibold clrgreen">{goalYear}</span>.{" "}
        <b>Congratulations!</b>
        </p>
        </div>
        </div>
      );
    }
    
    // --- Negative Impact (subtract) ---
    if (totalAmount <= 0) {
      return (
        <div className="row bg-light">
        <div className="col-md-2">
        <img
        src="/assets/images/Goal-Event.svg"
        alt="Warning"
        style={{ width: "6.2vw" }}
        />
        </div>
        <div className="col-md-10 pt-3">
        <p className="fs-14 fw-normal text-left w-100 mx-auto">
        This Goal Event could potentially impact{yours}{" "}
        <span className="fs-14 fw-semibold clrgreen">{goalName}</span> goal
        by{" "}
        <span className="fs-14 fw-semibold clrgreen">
        {formattedAmount}
        </span>
        . But don't worry, there are plenty of tools and techniques
        available to cover this gap in the years to come! We’ll connect
        again soon to discuss an action plan for the same.
        </p>
        </div>
        </div>
      );
    }
    
    // --- Default Fallback ---
    return (
      <div className="alert alert-info">
      No specific details available for this goal.
      </div>
    );
  };

  const handleSendClick = () => {
    Swal.fire({
      title: "Please check the client KYC",
      html: `
      <div style="text-align:left;">
        <p><strong>Before proceeding, please verify the client's KYC status:</strong></p>
        <div style="margin-top:10px;">
          <p><strong>Fresh Investment</strong> - KYC Validated</p>
          <p><strong>Existing Investment</strong> - KYC Registered or Validated</p>
          <p><strong>NRI</strong> - KYC Registered</p>
        </div>
      </div>
    `,
      icon: "warning",
      confirmButtonText: "OK",
      allowOutsideClick: false,
      customClass: {
        confirmButton: "swal-confirm-btn",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        sendEvent(); // existing functionality
      }
    });
  };

  return (
    <div className="goal-table-container mt-4">
    
      <NomineeDetailsDraft
        show={showNomineeAuthenticationModal}
        nomineeAuthenticationModalData={nomineeAuthenticationModalData}
        onHide={nomineeDetailsModalHide}
        setAlertMessage={setAlertMessage}
        alertMessage={alertMessage}
        proofType={"Nominee"}
        clientData={clientData}
        roomId={roomId}
        onSkip={handleSkipNominee}
      />
      <DiscardModal
        setIsDiscardRemark={setIsDiscardRemark}
        show={showDiscardModal}
        onHide={() => setShowDiscardModal(false)}
        roomId={roomId}
        initiatedFolios={initiatedFolios}
        getDraftGoalData={getDraftGoalData}
      />
      {/* <Toaster position="top-center" reverseOrder={false} /> */}
      <h3
        className="goal-table-header"
        // style={{
        //   fontSize: "1vw",
        //   background: "#fff",
        //   borderTop: "none",
        //   textAlign: "left",
        // }}
      >
        <span className="clrgreen">{isEventTitle}</span>
      </h3>

      <div className="scroll-container d-none d-md-block">
        {/* <div className="scroll-container d-md-block"> */}
        <table className="table">
          <thead className="sticky-header">
            <tr>
              <th className="txt-color-revers sticky-header back-clrgreen">
                Investor Name
              </th>
              <th className="txt-color-revers sticky-header back-clrgreen">
                Transaction Type
              </th>
              <th className="txt-color-revers sticky-header back-clrgreen">
                Fund Name
              </th>
              <th className="txt-color-revers sticky-header back-clrgreen">
                Amount
              </th>
              <th className="txt-color-revers sticky-header back-clrgreen">
                Status
              </th>
              {!validStatuses.includes(initiatedFolios[0]?.eventStatus) && (
                <th className=" txt-color-revers sticky-header back-clrgreen"></th>
              )}
            </tr>
          </thead>

          <tbody>
            {Object.keys(goalData).map((goalName) => {
              const folios = goalData[goalName].transactions || [];

              const sipFolios = folios.filter(
                (f) => f.tran_form_type === "SIP" && f.trans_status !== "Stop"
              );
              const lumpSumFolios = folios.filter(
                (f) => f.tran_form_type === "ReInvest"
              );
              const stpFolios = folios.filter(
                (f) => f.tran_form_type === "STP"
              );
              const sipStopFolios = folios.filter(
                (f) => f.tran_form_type === "Stop_sip"
              );
              const redeemFolios = folios.filter(
                (f) => f.tran_form_type === "Redeem"
              );

              const sipTotal = sipFolios.reduce(
                (acc, f) => acc + parseInt(f.tran_no_of_unites || 0),
                0
              );
              const lumpSumTotal = lumpSumFolios.reduce(
                (acc, f) => acc + parseInt(f.tran_no_of_unites || 0),
                0
              );
              const stpTotal = stpFolios.reduce(
                (acc, f) => acc + parseInt(f.tran_caluclate_amount || 0),
                0
              );
              const sipStopTotal = sipStopFolios.reduce(
                (acc, f) => acc + parseInt(f.tran_no_of_unites || 0),
                0
              );
              const redeemTotal = redeemFolios.reduce(
                (acc, f) => acc + parseInt(f.tran_no_of_unites || 0),
                0
              );

              return (
                <React.Fragment key={goalName}>
                  {/* Goal Header */}
                  <tr className="bgblue">
                    <th colSpan="6">
                      <p className="fs-14 my-2">{goalName}</p>
                    </th>
                  </tr>

                  {/* --- SIP Folios --- */}
                  {sipFolios.map((folio, i) => (
                    <tr key={folio._id || i}>
                      <td>{folio.investor_name}</td>
                      <td>SIP</td>
                      <td>{folio.tran_fund_name}</td>
                      <td>{formatRupees(folio.tran_no_of_unites)}</td>
                      <td>{folio.trans_status}</td>
                      {(!validStatuses.includes(
                        initiatedFolios[0]?.eventStatus
                      )&& (folio.trans_status!=="Executed"&&folio.trans_status!=="Processing")  ) && (
                          <td>
                            {console.log('t44',validStatuses.includes(
                        initiatedFolios[0]?.eventStatus),folio.trans_status,(folio.trans_status!=="Executed"&&folio.trans_status!=="Processing") )
                            }
                            <MdOutlineCancel
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveGoal(folio._id);
                              }}
                              className="text-danger ms-3 fs-4"
                            />
                          </td>
                        )}
                    </tr>
                  ))}
                  {sipFolios.length > 0 && (
                    <tr>
                      <td colSpan="3" className="text-end fw-semibold">
                        SIP Total:
                      </td>
                      <td>{formatRupees(sipTotal)}</td>
                      <td colSpan="2"></td>
                    </tr>
                  )}

                  {/* --- Lump Sum Folios --- */}
                  {lumpSumFolios.map((folio, i) => (
                    <tr key={folio._id || i}>
                      <td>{folio.investor_name}</td>
                      <td>Lump Sum</td>
                      <td>{folio.tran_fund_name}</td>
                      <td>{formatRupees(folio.tran_no_of_unites)}</td>
                      <td>{folio.trans_status}</td>
                      {(!validStatuses.includes(
                        initiatedFolios[0]?.eventStatus
                      )&& (folio.trans_status!=="Executed"&&folio.trans_status!=="Processing")  ) && (
                          <td>
                            <MdOutlineCancel
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveGoal(folio._id);
                              }}
                              className="text-danger ms-3 fs-4"
                            />
                          </td>
                        )}
                    </tr>
                  ))}
                  {lumpSumFolios.length > 0 && (
                    <tr>
                      <td colSpan="3" className="text-end fw-semibold">
                        Lump Sum Total:
                      </td>
                      <td>{formatRupees(lumpSumTotal)}</td>
                      <td colSpan="2"></td>
                    </tr>
                  )}

                  {/* --- STP Folios --- */}
                  {stpFolios.map((folio, i) => (
                    <tr key={folio._id || i}>
                      <td>{folio.investor_name}</td>
                      <td>STP</td>
                      <td>{folio.tran_fund_name ||folio.tran_out_fund}</td>
                      <td>{formatRupees(folio.tran_caluclate_amount)}</td>
                      <td>{folio.trans_status}</td>
                      {(!validStatuses.includes(
                        initiatedFolios[0]?.eventStatus
                      )&& (folio.trans_status!=="Executed"&&folio.trans_status!=="Processing")  ) && (
                          <td>
                            <MdOutlineCancel
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveGoal(folio._id);
                              }}
                              className="text-danger ms-3 fs-4"
                            />
                          </td>
                        )}
                    </tr>
                  ))}
                  {stpFolios.length > 0 && (
                    <tr>
                      <td colSpan="3" className="text-end fw-semibold">
                        STP Total:
                      </td>
                      <td>{formatRupees(stpTotal)}</td>
                      <td colSpan="2"></td>
                    </tr>
                  )}

                  {/* --- SIP Stop Folios --- */}
                  {sipStopFolios.map((folio, i) => (
                    <tr key={folio._id || i}>
                      <td>{folio.investor_name}</td>
                      <td>SIP Stop</td>
                      <td>{folio.tran_fund_name}</td>
                      <td>{formatRupees(folio.tran_no_of_unites)}</td>
                      <td>{folio.trans_status}</td>
                      {(!validStatuses.includes(
                        initiatedFolios[0]?.eventStatus
                      )&& (folio.trans_status!=="Executed"&&folio.trans_status!=="Processing")  ) && (
                          <td>
                            <MdOutlineCancel
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveGoal(folio._id);
                              }}
                              className="text-danger ms-3 fs-4"
                            />
                          </td>
                        )}
                    </tr>
                  ))}
                  {sipStopFolios.length > 0 && (
                    <tr>
                      <td colSpan="3" className="text-end fw-semibold">
                        SIP Stop Total:
                      </td>
                      <td>{formatRupees(sipStopTotal)}</td>
                      <td colSpan="2"></td>
                    </tr>
                  )}

                  {/* --- Redeem Folios --- */}
                  {redeemFolios.map((folio, i) => (
                    <tr key={folio._id || i}>
                      <td>{folio.investor_name}</td>
                      <td>Redeem</td>
                      <td>{folio.tran_fund_name}</td>
                      <td>{formatRupees(folio.tran_no_of_unites)}</td>
                      <td>{folio.trans_status}</td>
                      {(!validStatuses.includes(
                        initiatedFolios[0]?.eventStatus
                      )&& (folio.trans_status!=="Executed"&&folio.trans_status!=="Processing")  ) && (
                          <td>
                            <MdOutlineCancel
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveGoal(folio._id);
                              }}
                              className="text-danger ms-3 fs-4"
                            />
                          </td>
                        )}
                    </tr>
                  ))}
                  {redeemFolios.length > 0 && (
                    <tr>
                      <td colSpan="3" className="text-end fw-semibold">
                        Redeem Total:
                      </td>
                      <td>{formatRupees(redeemTotal)}</td>
                      <td colSpan="2"></td>
                    </tr>
                  )}

                  {/* Goal Message Row */}
                  <tr>
                    <td colSpan="6">
                      {getGoalMessage(
                        folios,
                        goalName,
                        folios[0]?.goal_folio_trans?.goalYear || ""
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>

          {/* Grand Footer */}
          <tfoot>
            <tr>
              <td colSpan={5} className="py-3">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    margin: "0px 10vw",
                    fontWeight: 700,
                    color: "#585858",
                  }}
                >
                  <li className="clrgreen" style={{ listStyleType: "none" }}>
                    TOTAL
                  </li>
                  <li
                    style={{ display: totals.sipStartTotal ? "block" : "none" }}
                    className="verify"
                  >
                    SIP Start{" "}
                    <span className="clrgreen">{formatRupees(totals.sipStartTotal)}</span>
                  </li>
                  <li
                    style={{
                      display: totals.lumpsumAmountTotal ? "block" : "none",
                    }}
                  >
                    Lump Sum Amount{" "}
                    <span className="clrgreen">
                      {formatRupees(totals.lumpsumAmountTotal)}
                    </span>
                  </li>
                  <li
                    style={{
                      display: totals.stpAmountTotal ? "block" : "none",
                    }}
                  >
                    STP Amount{" "}
                    <span className="clrgreen">{formatRupees(totals.stpAmountTotal)}</span>
                  </li>
                  <li
                    style={{ display: totals.sipStopTotal ? "block" : "none" }}
                  >
                    SIP Stop{" "}
                    <span className="clrgreen">{formatRupees(totals.sipStopTotal)}</span>
                  </li>
                  <li
                    style={{
                      display: totals.redeemAmountTotal ? "block" : "none",
                    }}
                  >
                    Redemption Amount{" "}
                    <span className="clrgreen">
                      {formatRupees(totals.redeemAmountTotal)}
                    </span>
                  </li>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      {/* Mobile View Card Layout */}

      <div className="d-block d-md-none">
        {Object.keys(goalData).map((goalName) => (
          <div
            key={goalName}
            className="border border-1 rounded-3 p-3 mb-3 bg-white shadow-sm"
          >
            <div
              className="d-flex justify-content-between align-items-center mb-2"
              onClick={() => toggleGoal(goalName)}
              style={{ cursor: "pointer" }}
            >
              <h5 className="fw-bold clrgreen m-0">{goalName}</h5>
              <span>{openGoals[goalName] ? <FaMinus /> : <FaPlus />}</span>
            </div>

            {openGoals[goalName] &&
              Array.isArray(goalData[goalName]?.transactions) && (
                <>
                  {goalData[goalName].transactions.map((folio, idx) => (
                    <div
                      key={idx}
                      className="border-top border-success pt-2 mt-2"
                    >
                      <div className="d-flex justify-content-between mb-1">
                        <span className="fw-semibold">Investor</span>
                        <span>{folio.investor_name}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-1">
                        <span className="fw-semibold">Transaction</span>
                        <span>
                          {folio.tran_financial_document_type === "ReInvest"
                            ? "Lump Sum"
                            : folio.tran_financial_document_type}
                          <IoInformationCircleOutline className="ms-2 text-success" />
                        </span>
                      </div>
                      <div className="d-flex justify-content-between mb-1">
                        <span className="fw-semibold">Fund</span>
                        <span>{folio.tran_fund_name}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-1">
                        <span className="fw-semibold">Amount</span>
                        <span>
                          {folio.tran_form_type === "STP"
                            ? formatRupees(folio.tran_caluclate_amount)
                            : formatRupees(folio.tran_no_of_unites) || ""}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between mb-1">
                        <span className="fw-semibold">Status</span>
                        <span>{folio.trans_status}</span>
                      </div>
                      <div className="text-end">
                      { (folio.trans_status!=="Executed"&&folio.trans_status!=="Processing") &&

                        <MdOutlineCancel
                          onClick={() => {
                            Swal.fire({
                              title: "Are you sure?",
                              text: "This transaction will be removed!",
                              icon: "warning",
                              showCancelButton: true,
                              confirmButtonColor: "#3085d6",
                              cancelButtonColor: "#d33",
                              confirmButtonText: "Yes, delete it!",
                            }).then(async (result) => {
                              if (result.isConfirmed) {
                                try {
                                  await api.post(`advisor/cancel_folios`, {
                                    id: folio._id,
                                    remarks: "Discarded from mobile view",
                                  });
                                  getDraftGoalData();
                                  Swal.fire(
                                    "Deleted!",
                                    "Transaction has been removed.",
                                    "success"
                                  );
                                } catch (err) {
                                  console.error(err);
                                  toast.error("Failed to remove transaction");
                                }
                              }
                            });
                          }}
                          className="text-danger fs-5"
                          style={{ cursor: "pointer" }}
                        />
                      }
                      </div>
                    </div>
                  ))}
                </>
              )}
          </div>
        ))}
      </div>

      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          margin: "0px 10vw",
          fontWeight: 700,
          color: "#585858",
        }}
      >
        <li className="clrgreen" style={{ listStyleType: "none" }}>
          TOTAL
        </li>
        <li
          style={{ display: totals.sipStartTotal ? "block" : "none" }}
          className="verify"
        >
          SIP Start <span className="clrgreen">₹ {totals.sipStartTotal}</span>
        </li>
        <li style={{ display: totals.lumpsumAmountTotal ? "block" : "none" }}>
          Lump Sum Amount{" "}
          <span className="clrgreen">₹ {totals.lumpsumAmountTotal}</span>
        </li>
        <li style={{ display: totals.stpAmountTotal ? "block" : "none" }}>
          STP Amount <span className="clrgreen">₹ {totals.stpAmountTotal}</span>
        </li>
        <li style={{ display: totals.sipStopTotal ? "block" : "none" }}>
          SIP Stop <span className="clrgreen">₹ {totals.sipStopTotal}</span>
        </li>
        <li style={{ display: totals.redeemAmountTotal ? "block" : "none" }}>
          Redemption Amount{" "}
          <span className="clrgreen">
            ₹ {parseInt(totals.redeemAmountTotal)}
          </span>
        </li>
      </div> */}

      <div
        className="gap-4"
        style={{
          margin: "3vw 25vw 1vw 25vw",
          paddingBottom: ".5vw",
          display: "flex",
          justifyContent: "space-evenly",
        }}
      >
        {isSend && (
          <button
            className="newBtn3 lrgbutton w-50 text-white uppercase"
            style={{
              minWidth: "10.5vw",
              display: [
                "Processed",
                "Sent",
                "Failed",
                "Rejected",
                "Resent",
                "Awaiting Authentication",
              ].includes(initiatedFolios[0]?.eventStatus)
                ? "none"
                : "inline-block",
            }}
            onClick={handleSendClick}
          >
            {initiatedFolios[0]?.eventStatus === "Editing" ? "DONE" : "SEND"}
          </button>
        )}
        {/* {console.log("jkdag",[
                "Processed",
                "Sent",
                "Failed",
                "Rejected",
                "Resent",
                "Awaiting Authentication",
              ].includes(initiatedFolios[0]?.eventStatus))} */}
        {isEdit && (
                  <button
                    className="newBtn3 lrgbutton w-50 text-white uppercase"
                    style={{
                      minWidth: "10.5vw",
                      display: ([
                        "Processed",
                        "Sent",
                        "Failed",
                        "Rejected",
                        "Resent",
                        "Awaiting Authentication",
                      ].includes(initiatedFolios[0]?.eventStatus))
                        ? "inline-block"
                        : "none",
                    }}
                    onClick={() => editEvent(initiatedFolios[0]?.goalEventId)}
                  >
                    EDIT
                  </button>
                )}

        {isDiscard && (
          <button
            className="newBtn3 lrgbutton w-50 text-white uppercase bg-secondary"
            style={{
              background: "#2a3f54",
              minWidth: "10.5vw",
              display:
               (( (initiatedFolios[0]?.eventStatus !== "Draft" &&initiatedFolios[0]?.eventStatus !== "Editing")||
               initiatedFolios?.some(folio=>folio.trans_status==="Processing"))
                  ? "none"
                  : "inline-block" ),
            }}
            onClick={() => discardEvent(initiatedFolios)}
          >
            DISCARD
          </button>
        )}
            {/* {console.log("initiatedFolios",initiatedFolios,(initiatedFolios[0]?.eventStatus !== "Draft" &&
                initiatedFolios[0]?.eventStatus !== "Editing"),initiatedFolios.some(folio=>folio.trans_status!=="Processing"))} */}

        
      </div>
    </div>
  );
};

export default DraftGoalTable;
